module.exports = __webpack_public_path__ + "media/images/admin/icons/git-pull-request-f4175c149b03388cf3e55933eb0a19af.svg";